import { Http } from './cloud-http';
import router from '../../router/router';
import { EventBus } from "@/common/eventbus";
const http = new Http({
    // 基础URL会拼接到各个请求url前面
    baseURL: SFERE_config.httpPath,
    // 请求超时时间
    timeout: SFERE_config.timeout,
    // 拦截所有请求，配置headers
    requestHandle(config) {
        //开启loading
        EventBus.$emit('showLoading');

        if (localStorage.length !== 0) {
            // 这里需要自己根据登录处理token和请求头
            const openId = localStorage.getItem("openId");
            const token = localStorage.getItem("token");
            config.headers["Content-Type"] = "application/json; charset=UTF-8";
            config.headers["Open-Id"] = openId;
            config.headers["Authorization"] = token;
        }


        return config;
    },
    // 拦截所有响应，统一处理消息
    responseHandle(response, error) {
        //关闭loading
        EventBus.$emit('hideLoading');

        if (response) {
            // 拦截所有未登录请求
            if (response.status === 401) {
                router.push({ path: "/checkLogin" });
            }
            return response;
        }

        //请求超时
        if (error && error.toString().indexOf('timeout') > -1) {
            const res = {
                data: {
                    Code: '500002',
                    Msg: 'timeout'
                }
            };
            return res;
        }

        const res = {
            data: {
                Code: '500001', Msg: 'Server error'
            }
        };
        return res;

    }
});
export default http;
